module.exports = __webpack_public_path__ + "static/media/Employer_3.b666bb85.svg";